var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":"","align-content":"center"}},[_c('v-col',{attrs:{"cols":12}},[_c('div',{staticClass:"text-h6l px-0",staticStyle:{"color":"black"}},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }